import ImportACHPage, { getDefaultData, getDefaultUI } from "components/pages/ImportACHPage";
import { BCMSStateManagerCRUD, BCMSRecord, useBCMSContext } from "bcms-react";
import Classes, { ParticipantImportTemplate } from "model";

/**
 * @name CaptureParticipantImportTemplatesNameMapped
 * @returns {React.Component}
 * @description 
 * This capture is used in the following capture groups:
 * "ACH Import File (Participants)" (abi22).
 */
export default function CaptureParticipantImportTemplatesNameMapped(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    
    const template = ParticipantImportTemplate.init({ templateName: "Payroll_Participants", participantName: "1" });

    const data = BCMSStateManagerCRUD.init(getDefaultData())
    .update([ "participantImportTemplatesWidgetData", "template" ], template)
    .submit();
    
    const ui = BCMSStateManagerCRUD.init(getDefaultUI())
    .update([ "participantImportTemplatesWidgetUI", "showAddTemplateFormView" ], true)
    .submit();

    return <ImportACHPage data={ data } ui={ ui } />;
}